import { useEffect, useRef, useState } from "react";
import axios from "../api/axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { io } from "socket.io-client";
import Leaderboard from "./Leaderboard";
import "../../Quiz-app/css/quiz-related.css";
import { CircularProgress } from "@mui/material";
import userStore from "../../../zustand/userStore";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import { BASE_URL } from "../../../configs/WebServiceUrl";
import CompletionPopUp from "../../Quiz-app/pages-new/CompletionPopUp";
// import { FaUserCircle } from "react-icons/fa";
// import { FaCircleUser } from "react-icons/fa6";
// import { BiCrown } from "react-icons/bi";

export default function StartQuiz2() {
  const userData = userStore((state) => state.user);
  const location = useLocation();
  const state = location.state;
  // const state = location.state || JSON.parse(sessionStorage.getItem("currentQuiz")) || {};
  const { quizType, quiz_id, class_id, group_id, theme_group_id } = state || {};
  const [questions, setQuestions] = useState([]);
  const [totalMarks, setTotalMarks] = useState("");
  // answeredStatus[i] mirrors questions[i] by position — one of
  // "unanswered", "answered", or "skipped". Seeded from the backend on
  // load so it's correct even on a fresh device/browser, not just a
  // same-tab refresh.
  const [answeredStatus, setAnsweredStatus] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [countdown, setCountdown] = useState(30);
  const [questionDuration, setQuestionDuration] = useState(30);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [showAnswer, setShowAnswer] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null);
  const [correctOption, setCorrectOption] = useState(null);
  const [loader, setLoader] = useState(true);

  const [showCompletion, setShowCompletion] = useState(false);
  const [popUp, setPopup] = useState(false);
  // console.log("nif", state);
  const hasSubmittedRef = useRef(false);
  const timerRef = useRef(null);
  const socketRef = useRef(null);
  const isMountedRef = useRef(true);

  //   const location = useLocation();
  //   const { state } = location;
  //   const { quizType } = state;
  const navigate = useNavigate();
  //   const { quiz_id } = useParams();

  useEffect(() => {
    isMountedRef.current = true;
    window.addEventListener("beforeunload", preventReload);
    window.addEventListener("keydown", blockReloadKeys);
    window.addEventListener("contextmenu", preventContextMenu);

    return () => {
      isMountedRef.current = false;
      clearInterval(timerRef.current);
      window.removeEventListener("beforeunload", preventReload);
      window.removeEventListener("keydown", blockReloadKeys);
      window.removeEventListener("contextmenu", preventContextMenu);
      // socketRef.current?.disconnect(); // Disconnect socket on unmount
    };
  }, []);

  const preventReload = (e) => {
    e.preventDefault();
    e.returnValue =
      "Are you sure you want to leave? Your progress will be lost.";
  };

  const blockReloadKeys = (e) => {
    const isReloadKey =
      e.key === "F5" ||
      ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "r");
    if (isReloadKey) {
      e.preventDefault();
      e.stopPropagation();
      alert("❌ Reload is disabled during the quiz!");
    }
  };

  const preventContextMenu = (e) => {
    e.preventDefault();
  };

  // Single source of truth for "which class/group is this student answering
  // under" — used by fetchQuestions, submitAnswer, and the join-time
  // leaderboard push, so all three always agree instead of drifting apart.
  // const deriveClassAndGroupParams = () => {
  //   const rawStudentDetails = userData?.student_details;
  //   let studentDetails = rawStudentDetails;

  //   if (typeof rawStudentDetails === "string") {
  //     try {
  //       studentDetails = JSON.parse(rawStudentDetails);
  //     } catch (error) {
  //       let depth = 0;
  //       let inString = false;
  //       let escaped = false;
  //       let endIndex = -1;

  //       for (let index = 0; index < rawStudentDetails.length; index += 1) {
  //         const character = rawStudentDetails[index];

  //         if (inString) {
  //           if (escaped) {
  //             escaped = false;
  //           } else if (character === "\\") {
  //             escaped = true;
  //           } else if (character === '"') {
  //             inString = false;
  //           }
  //           continue;
  //         }

  //         if (character === '"') {
  //           inString = true;
  //         } else if (character === "{") {
  //           depth += 1;
  //         } else if (character === "}") {
  //           depth -= 1;
  //           if (depth === 0) {
  //             endIndex = index + 1;
  //             break;
  //           }
  //         }
  //       }

  //       if (endIndex > 0) {
  //         try {
  //           studentDetails = JSON.parse(rawStudentDetails.slice(0, endIndex));
  //         } catch (fallbackError) {
  //           studentDetails = null;
  //         }
  //       }
  //     }
  //   }

  //   const studentClass = studentDetails?.student_class;
  //   let classParam = "";
  //   let groupParam = "";

  //   if (quizType === 1) {
  //     // Live quiz → use the student's own class
  //     classParam = studentClass;
  //   } else if (quizType === 2) {
  //     // Practice quiz → use the selected class_id, if any
  //     if (class_id) classParam = class_id;
  //     // } else if (quizType === 3) {
  //     //   // Thematic quiz → derive group_id by matching student's class in group_id array
  //     //   if (Array.isArray(theme_group_id)) {
  //     //     const matchedGroup = theme_group_id.find((g) =>
  //     //       g.class_ids.some((id) => Number(id) === Number(studentClass))
  //     //     );
  //     //     if (matchedGroup) groupParam = matchedGroup.group_id;
  //     //   }
  //   } else if (quizType === 3) {
  //     // Thematic live quiz → derive group_id by matching student's class
  //     // Handle class_ids when it is either an array or a single value.
  //     if (Array.isArray(theme_group_id)) {
  //       const matchedGroup = theme_group_id.find((g) => {
  //         const rawClassIds = g?.class_ids;

  //         if (Array.isArray(rawClassIds)) {
  //           return rawClassIds.some(
  //             (id) => Number(id) === Number(studentClass),
  //           );
  //         }

  //         if (rawClassIds !== undefined && rawClassIds !== null) {
  //           return Number(rawClassIds) === Number(studentClass);
  //         }

  //         return false;
  //       });

  //       if (matchedGroup) {
  //         groupParam = matchedGroup.group_id;
  //       }
  //     }
  //   } else if (quizType === 4) {
  //     // Another thematic type → use group_id directly
  //     if (group_id) groupParam = group_id;
  //   }

  //   return { classParam, groupParam };
  // };
  // const deriveClassAndGroupParams = () => {
  //   console.log("userData", JSON.stringify(userData));
  //   const rawStudentDetails = userData?.student_details;
  //   let studentDetails = rawStudentDetails;

  //   if (typeof rawStudentDetails === "string") {
  //     try {
  //       studentDetails = JSON.parse(rawStudentDetails);
  //     } catch (error) {
  //       let depth = 0;
  //       let inString = false;
  //       let escaped = false;
  //       let endIndex = -1;

  //       for (let index = 0; index < rawStudentDetails.length; index += 1) {
  //         const character = rawStudentDetails[index];

  //         if (inString) {
  //           if (escaped) {
  //             escaped = false;
  //           } else if (character === "\\") {
  //             escaped = true;
  //           } else if (character === '"') {
  //             inString = false;
  //           }

  //           continue;
  //         }

  //         if (character === '"') {
  //           inString = true;
  //         } else if (character === "{") {
  //           depth += 1;
  //         } else if (character === "}") {
  //           depth -= 1;

  //           if (depth === 0) {
  //             endIndex = index + 1;
  //             break;
  //           }
  //         }
  //       }

  //       if (endIndex > 0) {
  //         try {
  //           studentDetails = JSON.parse(rawStudentDetails.slice(0, endIndex));
  //         } catch (fallbackError) {
  //           studentDetails = null;
  //         }
  //       }
  //     }
  //   }

  //   const studentClass = studentDetails?.student_class;

  //   let classParam = "";
  //   let groupParam = "";

  //   if (quizType === 1) {
  //     // Live academic quiz → use student's own class
  //     classParam = studentClass;
  //   } else if (quizType === 2) {
  //     // Practice academic quiz → use selected class_id
  //     if (class_id) {
  //       classParam = class_id;
  //     }
  //   } else if (quizType === 3) {
  //     // Thematic quiz → derive group_id by matching student's class in group_id array.
  //     // class_ids should already be an array from the backend, but guard against a
  //     // still-a-JSON-string (or missing) value so one bad entry can't crash the quiz.
  //     if (Array.isArray(theme_group_id)) {
  //       const matchedGroup = theme_group_id.find(
  //         (g) =>
  //           Array.isArray(g.class_ids) &&
  //           g.class_ids.some((id) => Number(id) === Number(studentClass)),
  //       );
  //       if (matchedGroup) groupParam = matchedGroup.group_id;
  //     }
  //   } else if (quizType === 4) {
  //     // Practice thematic quiz → use group_id directly
  //     if (group_id) {
  //       groupParam = group_id;
  //     }
  //   }

  //   return { classParam, groupParam };
  // };
  const deriveClassAndGroupParams = () => {
    console.log("========== deriveClassAndGroupParams ==========");
    console.log("userData:", userData);
    console.log("quizType:", quizType);
    console.log("class_id:", class_id);
    console.log("group_id:", group_id);
    console.log("theme_group_id:", theme_group_id);

    const rawStudentDetails = userData?.student_details;

    console.log("rawStudentDetails:", rawStudentDetails);
    console.log("rawStudentDetails type:", typeof rawStudentDetails);

    let studentDetails = rawStudentDetails;

    if (typeof rawStudentDetails === "string") {
      try {
        studentDetails = JSON.parse(rawStudentDetails);
      } catch (error) {
        console.error("student_details JSON parse failed:", error);
        studentDetails = null;
      }
    }

    console.log("studentDetails:", studentDetails);

    const studentClass = studentDetails?.student_class;

    console.log("studentClass:", studentClass);

    let classParam = "";
    let groupParam = "";

    if (Number(quizType) === 1) {
      classParam = studentClass;
    } else if (Number(quizType) === 2) {
      if (class_id) {
        classParam = class_id;
      }
    } else if (Number(quizType) === 3) {
      console.log("THEMATIC quiz");

      if (Array.isArray(theme_group_id)) {
        const matchedGroup = theme_group_id.find((g) => {
          return (
            Array.isArray(g.class_ids) &&
            g.class_ids.some((id) => Number(id) === Number(studentClass))
          );
        });

        console.log("matchedGroup:", matchedGroup);

        if (matchedGroup) {
          groupParam = matchedGroup.group_id;
        }
      }
    } else if (Number(quizType) === 4) {
      if (group_id) {
        groupParam = group_id;
      }
    }

    console.log("FINAL classParam:", classParam);
    console.log("FINAL groupParam:", groupParam);

    return { classParam, groupParam };
  };
  useEffect(() => {
    if (state?.quiz_id && state?.quizType) {
      fetchQuestions();
    } else {
      setLoader(false);
    }
  }, []);

  const fetchQuestions = async () => {
    try {
      setLoader(true);

      const { classParam, groupParam } = deriveClassAndGroupParams();
      console.log("hi");
      const extraParam = classParam
        ? `&class_id=${classParam}`
        : groupParam
          ? `&group_id=${groupParam}`
          : "";

      // 🟢 Build API URL
      const url = `/student/get-questions?quiz_id=${quiz_id}&quiz_type=${quizType}${extraParam}`;
      const res = await axios.get(url);

      const duration = res.data.duration_per_question || 30;
      setQuestionDuration(duration);
      setQuestions(res.data.questions);
      setTotalMarks(res?.data?.total_marks || 0);

      // Which of these questions has the student already answered/skipped —
      // authoritative (DB-backed) so it's correct even on a fresh device,
      // not just a same-tab refresh. Each entry is "unanswered", "answered"
      // or "skipped".
      let initialStatus = new Array(res.data.questions.length).fill(
        "unanswered",
      );
      let resumeAt = 0;
      try {
        const answeredRes = await axios.get(
          `/student/answered-questions?quiz_id=${quiz_id}&user_id=${userData?.id}&quiz_type=${quizType}${extraParam}`,
        );
        const answeredIds = new Set(answeredRes.data.answered_question_ids);
        const skippedIds = new Set(answeredRes.data.skipped_question_ids);
        initialStatus = res.data.questions.map((q) => {
          if (answeredIds.has(q.id)) return "answered";
          if (skippedIds.has(q.id)) return "skipped";
          return "unanswered";
        });
        const firstUnanswered = initialStatus.findIndex(
          (status) => status === "unanswered",
        );
        resumeAt =
          firstUnanswered === -1 ? initialStatus.length - 1 : firstUnanswered;
      } catch (err) {
        console.error("Error loading answered-questions status:", err);
        // Fall back to starting at question 0 with nothing marked answered
        // rather than blocking the quiz over a non-critical status fetch.
      }
      setAnsweredStatus(initialStatus);
      setLoader(false);

      // Restore progress if available — only trust the finer-grained
      // sessionStorage snapshot (selected/countdown/startTime) when it
      // agrees with the backend on which question we're resuming at;
      // otherwise start that question fresh with a full countdown.
      const saved = sessionStorage.getItem(`quiz_${quiz_id}_progress`);
      const parsed = saved ? JSON.parse(saved) : null;
      if (parsed && parsed.current === resumeAt) {
        setCurrent(resumeAt);
        setSelected(parsed.selected || "");
        setCountdown(parsed.countdown || duration);
        setStartTime(parsed.startTime || Date.now());
      } else {
        setCurrent(resumeAt);
        setCountdown(duration);
        setStartTime(Date.now());
      }
    } catch (err) {
      alert("Error loading quiz questions.");
      setLoader(false);
    }
  };

  // Real-time leaderboard with Socket.IO
  useEffect(() => {
    if (!quiz_id) return;

    // socketRef.current = io("https://web1024.docmaster.in:5007"); // 🔁 Replace with your backend URL
    // socketRef.current = io("https://web1024.docmaster.in:5010", {
    // socketRef.current = io(BASE_URL, {
    //   extraHeaders: {
    //     ...apiKeyHeader(),
    //   },
    // }); // 🔁 Replace with your backend URL
    socketRef.current = io(BASE_URL);
    // socketRef.current = io("http://192.168.0.230:5007"); // 🔁 Replace with your backend URL

    // Same derivation submitAnswer uses — a live quiz never carries class_id
    // in route state, so joining with the raw class_id/group_id here would
    // silently produce an empty leaderboard for quiz_type 1/3.
    const joinQuizRoom = () => {
      const { classParam, groupParam } = deriveClassAndGroupParams();
      socketRef.current.emit("joinQuiz", {
        quiz_id,
        quiz_type: quizType,
        class_id: classParam || null,
        group_id: groupParam || null,
      });
    };

    // "connect" fires on the first connection AND every time the socket
    // reconnects after being dropped (network blip, backend restart) —
    // room membership doesn't survive a reconnect, so without re-joining
    // here this tab would silently stop receiving leaderboard broadcasts
    // after any disconnect, even though it still looks "connected".
    socketRef.current.on("connect", joinQuizRoom);

    socketRef.current.on("leaderboardUpdated", (data) => {
      console.log("data", data);
      setLeaderboard(data);
    });

    return () => {
      socketRef.current?.off("connect", joinQuizRoom);
      socketRef.current?.disconnect();
    };
  }, [quiz_id]);

  useEffect(() => {
    sessionStorage.setItem(
      `quiz_${quiz_id}_progress`,
      JSON.stringify({
        current,
        selected,
        countdown,
        startTime,
      }),
    );
  }, [current, selected, countdown, startTime]);

  useEffect(() => {
    if (!questions.length) return;

    setCountdown(questionDuration);
    setStartTime(Date.now());
    clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (!isMountedRef.current) return prev;

        if (prev <= 1) {
          clearInterval(timerRef.current);
          submitAnswer(true);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [current, questionDuration, questions.length]);

  const handleOptionSelect = (label) => {
    setSelected(label);
  };

  const submitAnswer = async (auto = false, skip = false) => {
    if (hasSubmittedRef.current || isSubmitting) return;

    hasSubmittedRef.current = true;
    setIsSubmitting(true);

    const q = questions[current];
    if (!q) return;

    const timeTaken = Date.now() - startTime;
    // An explicit Skip discards any option the student may have already
    // clicked — it must submit as unanswered regardless of `selected`,
    // not silently fall back to whatever happens to be highlighted.
    const selectedOption = skip ? null : selected;
    // Also clear the visible selection state itself — otherwise a stale
    // pre-skip click still renders as "selected" (and gets highlighted
    // red/wrong) in the answer-reveal UI below, even though the request
    // just sent to the server correctly recorded this as a skip.
    if (skip && selected) {
      setSelected("");
    }

    console.log("Submitting Answer:", {
      question_id: q.id,
      user_id: userData?.id,
      selected_option: selectedOption,
      time_taken_ms: selectedOption ? timeTaken : questionDuration * 1000,
      quiz_id,
    });

    // ✅ Derive class_id / group_id based on quiz type
    const { classParam, groupParam } = deriveClassAndGroupParams();

    try {
      // ✅ Include correct params in submit-answer request
      // Correctness now comes from the server response, not a client-side
      // guess — the questions payload no longer carries correct_option.
      const res = await axios.post(`/student/submit-answer`, {
        question_id: q.id,
        user_id: userData?.id,
        selected_option: selectedOption || null,
        time_taken_ms: selectedOption ? timeTaken : questionDuration * 1000,
        quiz_id,
        quiz_type: quizType,
        class_id: classParam || null,
        group_id: groupParam || null,
      });

      setIsCorrect(res.data.is_correct);
      setCorrectOption(res.data.correct_option);
      setShowAnswer(true);
      setAnsweredStatus((prev) => {
        const next = [...prev];
        // Covers both the explicit Skip button and the timer running out
        // with nothing selected — either way, no real answer was given.
        next[current] = selectedOption ? "answered" : "skipped";
        return next;
      });

      // 🔁 Ask backend to update leaderboard
      socketRef.current?.emit("requestLeaderboardUpdate", quiz_id);
    } catch (err) {
      console.error("Answer submission failed:", err);
      // No server verdict to show — leave showAnswer off rather than
      // display a misleading/blank correctness state for this question.
    }

    // ✅ If there are more questions → next question
    if (current + 1 < questions.length) {
      setTimeout(() => {
        setCurrent((prev) => prev + 1);
        setSelected("");
        setIsSubmitting(false);
        setShowAnswer(false);
        setIsCorrect(null);
        setCorrectOption(null);
        hasSubmittedRef.current = false;
      }, 2000);
    } else {
      // ✅ Complete quiz logic
      let extraParam = "";

      if (classParam) {
        extraParam = `&class_id=${classParam}`;
      } else if (groupParam) {
        extraParam = `&group_id=${groupParam}`;
      }

      try {
        await axios.post(
          `/student/complete-quiz?user_id=${userData.id}&quiz_id=${quiz_id}&quiz_type=${quizType}${extraParam}`,
          {},
        );

        sessionStorage.removeItem(`quiz_${quiz_id}_progress`);
        setShowCompletion(true);
        setPopup(true);
        setTimeout(() => {
          setPopup(false);
          setShowCompletion(false);
          // navigate("/quiz-dashboard/dashboard");
          navigate("/quiz-dashboard/completeQuizzes");
        }, 4000);
      } catch (err) {
        console.error("Error completing quiz:", err);

        const errorMessage =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Unable to complete the quiz.";

        if (
          errorMessage ===
          "Quiz already marked as completed for this class/group."
        ) {
          alert(
            `${errorMessage}\n\nOnly the initial practice quiz participation is stored.`,
          );

          sessionStorage.removeItem(`quiz_${quiz_id}_progress`);

          navigate("/quiz-dashboard/completeQuizzes");
        }
      }
    }
  };

  if (loader) {
    return (
      <div
        style={{
          textAlign: "center",
          paddingTop: "80px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
        }}
      >
        <CircularProgress />
        {/* <p style={{ fontSize: "16px", color: "#555" }}>Loading questions...</p> */}
      </div>
    );
  }
  if (!questions.length) {
    return (
      <p
        style={{
          textAlign: "center",
          paddingTop: "60px",
          fontSize: "50px",
          color: "black",
        }}
      >
        No questions found
      </p>

      // <div className="loading text-center">
      //   <div className="spinner mb-10"></div>
      //   <p>Loading questions...</p>
      // </div>
    );
  }
  // if (questions.length === 0) {
  //   return <p>No questions found</p>;
  // }

  const q = questions[current];
  const progress = ((current + 1) / questions.length) * 100;
  const answeredCount = answeredStatus.filter((s) => s === "answered").length;
  const skippedCount = answeredStatus.filter((s) => s === "skipped").length;
  const totalQuestions = questions.length;

  return (
    <div className="w-100">
      {state?.quizType && state?.quiz_id && (
        <div className="w-100">
          {popUp && <CompletionPopUp />}
          {loader && <CircularProgress />}
          {/* Left: Quiz Content */}
          {/* <div className="w-2/3"> */}
          {/* <div style={{ width: "90%" }}> */}
          {/* <div style={{ width: "40%" }}> */}
          <div className="row w-100 mt-0">
            <div className="col-md-9">
              {/* Answered / Skipped / Total summary — centered, above the question card */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "22px",
                  marginBottom: "12px",
                  fontSize: "14px",
                  fontWeight: "600",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <span style={{ color: "#4CAF50" }}>
                  Answered: {answeredCount}
                </span>
                <span style={{ color: "#FF9800" }}>
                  Skipped: {skippedCount}
                </span>
                <span style={{ color: "#333" }}>Total: {totalQuestions}</span>
              </div>
              <div
                className="w-100 "
                style={{
                  // backgroundImage: "url(/images/1.png)",
                  borderRadius: "20px",
                  color: "#fff",
                  // border: "1px solid red",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100%",
                  // padding: "4% 4% 0px 10%",
                  // height: "100vh",
                  // minHeight: "80vh",
                }}
              >
                {/* <div
                  className="card p-4 striped-border rounded"
                  style={{
                    backgroundColor: "transparent",
                    padding: "0",
                    width: "100%",
                    boxShadow: "none",
                    position: "relative", // ✅ Added
                    minHeight: "70vh", // ✅ Ensures proper space
                  }}
                > */}
                <div className="card striped-border rounded quiz-card">
                  {/* FIXED HEADER */}
                  <div className="quiz-header">
                    <div className="progress">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${progress}%`,
                          backgroundColor: "#4caf50",
                          height: "7px",
                        }}
                      />
                    </div>

                    <div className="quiz-question-header">
                      <h3>Question {current + 1}</h3>

                      <p
                        className={
                          countdown <= 5
                            ? "text-red-600 border border-red-600 p-1 rounded"
                            : ""
                        }
                      >
                        ⏳ Time left: <b>{countdown}s</b>
                      </p>
                    </div>
                  </div>

                  {/* SCROLLABLE CONTENT */}
                  <div className="quiz-content">
                    <p
                      className="text-black"
                      style={{
                        fontSize: "16px",
                        lineHeight: "1.5",
                        overflowWrap: "anywhere",
                      }}
                    >
                      {q.content}
                    </p>

                    <div className="grid grid-cols-2 gap-2 mb-3 quiz-options">
                      {q.options.map((opt) => {
                        const isSelected = selected === opt.label;
                        const isCorrectOption = opt.label === correctOption;

                        let style = {
                          padding: "12px 16px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          cursor: "pointer",
                          fontWeight: "500",
                          transition: "all 0.3s ease",
                          textAlign: "left",
                          whiteSpace: "normal",
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                          backgroundColor: "#f0f0f0",
                          color: "#000",
                        };

                        if (showAnswer) {
                          if (isCorrectOption) {
                            // Correct answer
                            style.backgroundColor = "#4CAF50";
                            style.color = "#fff";
                            style.border = "1px solid #4CAF50";
                          } else if (isSelected && !isCorrectOption) {
                            // User selected wrong answer
                            style.backgroundColor = "#F44336";
                            style.color = "#fff";
                            style.border = "1px solid #F44336";
                          }
                        } else if (isSelected) {
                          // Selected before submitting
                          style.backgroundColor = "#1976D2";
                          style.color = "#fff";
                          style.border = "1px solid #1976D2";
                        }

                        return (
                          <button
                            className="text-left btn-option"
                            key={opt.label}
                            style={style}
                            disabled={showAnswer}
                            onClick={() => handleOptionSelect(opt.label)}
                          >
                            {opt.label}: {opt.content}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* FIXED FOOTER */}
                  <div className="quiz-footer">
                    {showAnswer ? (
                      <p
                        className={`font-semibold ${
                          isCorrect ? "text-green-600" : "text-red-600"
                        }`}
                      >
                        {isCorrect
                          ? "✅ Correct!"
                          : `❌ Incorrect! Correct answer: ${correctOption}`}
                      </p>
                    ) : (
                      <span />
                    )}

                    <div className="quiz-actions">
                      <button
                        className="skip-btn"
                        onClick={() => submitAnswer(false, true)}
                        disabled={isSubmitting || showAnswer}
                      >
                        Skip
                      </button>

                      <button
                        className="btn btn-success"
                        onClick={() => submitAnswer()}
                        disabled={!selected || isSubmitting || showAnswer}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              {/* Right: Leaderboard */}
              {(quizType === 1 || quizType === 3) && (
                <Leaderboard
                  leaderboard={leaderboard}
                  questions={questions}
                  totalMarks={totalMarks}
                />
              )}{" "}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    minHeight: "90vh",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: "fadeIn 0.4s ease",
  },
  popup: {
    backgroundColor: "#fff",
    padding: "40px 60px",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    animation: "zoomIn 0.4s ease",
  },
  emoji: {
    fontSize: "30px",
    marginBottom: "16px",
    fontWeight: "bold",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#2e7d32",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "16px",
    color: "#333",
  },
};
